import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { SettingsActions } from 'src/app/ngrx/settings/settings.actions';
import { LOGGER } from 'src/app/oidc/shared/logger';

@Injectable({ providedIn: 'root' })
export class WizardService {
  private readonly store = inject(Store);
  private readonly log = inject(LOGGER).scope('wizard');

  complete(id: string): void {
    this.log.debug('step completed', { id });
    this.store.dispatch(SettingsActions.wizardStepCompleted({ id }));
  }
}
